import { mdx } from '@readme/markdown';

export const deserialize = node => {
  const text = mdx(node).trim();

  return { text };
};
